
export function capitalize(str){
        return str[0].toUpperCase() + str.slice(1);
}

// export function gradient({width, height,colora, colorb}){
//     return(
//         <svg height={ height } width={ width }>
//             <defs>
//                 <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
//                     <stop offset="0%" stopColor={colora} stopOpacity="1" />
//                     <stop offset="100%" stopColor={colorb} stopOpacity="1" />
//                 </linearGradient>
//             </defs>
//             <rect width={width} height={height} fill="url(#grad1)" />
//         </svg>
//     )
// }
//<ellipse cx="200" cy="70" rx="85" ry="55" fill="url(#grad1)" />



// WEBPACK FOOTER //
// ./src/lib/helpers.js